import { ErrorPage } from "@/components/ui/error-page";

export default function Forbidden() {
  return (
    <ErrorPage
      code="403"
      title="Access Forbidden"
      subtitle="You don't have permission to access this resource"
    />
  );
}
